import React from 'react';

import AuthUserContext from './context';
import { ProfileContext } from './profile';
import { withFirebase } from '../Firebase';
import { syncProfileEmail, watchProfile } from '../../services/users';
import { effectiveProfile, readExternalPreview, watchExternalPreview } from './preview';

// Fournit à toute l'app l'utilisateur Firebase connecté (AuthUserContext) et sa fiche users/{uid}
// avec son rôle (ProfileContext, modèle v2) ; administrateur en « vue externe » : profil d'un externe (./preview.js).
const withAuthentication = Component => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        authUser: null,
        profile: undefined,
        preview: readExternalPreview(),
      };
    }

    componentDidMount() {
      this.unwatchPreview = watchExternalPreview(preview => this.setState({ preview }));
      this.listener = this.props.firebase.auth.onAuthStateChanged(authUser => {
        if (this.unwatchProfile) this.unwatchProfile();
        this.unwatchProfile = null;
        this.setState({ authUser: authUser || null, profile: authUser ? undefined : null });
        if (authUser) {
          this.unwatchProfile = watchProfile(
            authUser.uid,
            profile => {
              this.setState({ profile });
              // Fiche avec un e-mail faux ou absent : celui du compte de connexion (une tentative par connexion).
              if (profile && authUser.email && profile.email !== authUser.email && this.emailSynced !== authUser.uid) {
                this.emailSynced = authUser.uid;
                syncProfileEmail(authUser.uid, authUser.email)
                  .catch(err => console.warn('Profile email not updated:', err.code || err.message));
              }
            },
            () => this.setState({ profile: null }),
          );
        }
      });
    }

    componentWillUnmount() {
      this.listener();
      if (this.unwatchProfile) this.unwatchProfile();
      this.unwatchPreview();
    }

    // Même objet tant que le profil et l'aperçu ne changent pas (dépendances des effets des pages).
    profileFor(profile, preview) {
      if (this.lastProfile !== profile || this.lastPreview !== preview) {
        this.lastProfile = profile;
        this.lastPreview = preview;
        this.shownProfile = effectiveProfile(profile, preview);
      }
      return this.shownProfile;
    }

    render() {
      return (
        <AuthUserContext.Provider value={this.state.authUser}>
          <ProfileContext.Provider value={this.profileFor(this.state.profile, this.state.preview)}>
            <Component {...this.props} />
          </ProfileContext.Provider>
        </AuthUserContext.Provider>
      );
    }
  }

  return withFirebase(WithAuthentication);
};

export default withAuthentication;
